import { ChangeDetectionStrategy, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import {
    IChecklist2ReportAnswer,
    IChecklist2ReportChecklistSummary,
    IChecklist2ReportChecklistUnits,
    IChecklistV2ReportParameterFilter,
} from '../../../shared/fi-checklist2-report';
import { BehaviorSubject } from 'rxjs';
import { FiChecklist2ReportHelperService } from '../../../services/fi-checklist2-report-helper.service';
import { FiChecklist2ReportHistoryService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-history.service';
import { FiChecklist2ReportTimePeriodType } from '@fi-shared/checklist/fi-checklist2-report/enums/fi-checklist2-report-time-period-type';
import { FiChecklist2ReportType } from '@fi-shared/checklist/fi-checklist2-report/enums/fi-checklist2-report-type';
import { FileType } from '@fi-shared/types';

export interface IChecklistUnitAnswerDetailsDialogData {
    checklistSummary: IChecklist2ReportChecklistSummary;
    checklistUnits: IChecklist2ReportChecklistUnits;
    reportType: FiChecklist2ReportType;
    auditMode: boolean;
    filter: IChecklistV2ReportParameterFilter;
}
@Component({
    selector: 'fi-checklist-unit-answers-details-dialog',
    templateUrl: './checklist-unit-answers-details-dialog.component.html',
    styleUrls: ['./checklist-unit-answers-details-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-unit-answers-details-dialog' },
    standalone: false,
})
export class FiChecklistUnitAnswerDetailsDialogComponent
    extends FiDialogsContentBase<IChecklistUnitAnswerDetailsDialogData, void>
    implements OnInit
{
    sortedAnswers$ = new BehaviorSubject<IChecklist2ReportAnswer[]>([]);

    ngOnInit() {
        this.sortedAnswers$.next(this.data.checklistUnits.AnswerDetails);
        this.setServices();
        this.data.checklistSummary.ChecklistName;
    }

    downloadReport() {
        this.fiChecklist2ReportHistoryService.downloadAnswerDetailsReport({
            currentFilter: this.data.filter,
            checklistHistoryDateRange: {
                TimePeriodType: FiChecklist2ReportTimePeriodType.Custom,
                StartDate: new Date(this.data.checklistUnits.AnswerDetails[0].PeriodStartDateTime),
                EndDate: new Date(this.data.checklistUnits.AnswerDetails[0].PeriodDueDateTime),
            },
            reportType: this.data.reportType,
            auditMode: this.data.auditMode,
            reportFormat: FileType.Excel,
        });
    }

    getDialogHeader(): string {
        return (
            this.data.checklistUnits.BusinessUnitName +
            ' - ' +
            this.data.checklistSummary.ChecklistName +
            ', ' +
            this.data.checklistSummary.ScheduleName
        );
    }

    closeDialog() {
        this.dialogRef.close();
    }

    getTotalCheckpointsCount(): number {
        return this.fiChecklist2ReportHelperService.getChecklistUnitsTotalCheckpoints(this.data.checklistUnits);
    }

    getFilledCheckpointsCount(): number {
        return this.fiChecklist2ReportHelperService.getChecklistUnitsFilledCheckpoints(this.data.checklistUnits);
    }

    private fiChecklist2ReportHelperService: FiChecklist2ReportHelperService;
    private fiChecklist2ReportHistoryService: FiChecklist2ReportHistoryService;

    private setServices() {
        this.fiChecklist2ReportHelperService = this.injector.get(FiChecklist2ReportHelperService);
        this.fiChecklist2ReportHistoryService = this.injector.get(FiChecklist2ReportHistoryService);
    }
}
